import { render, staticRenderFns } from "./_ModuleEntityNeedAccess.vue?vue&type=template&id=230f4193&scoped=true&"
import script from "./_ModuleEntityNeedAccess.vue?vue&type=script&lang=js&"
export * from "./_ModuleEntityNeedAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f4193",
  null
  
)

export default component.exports